import { createServiceStore } from 'common/store';
import { customActions } from './custom-actions';
import { initialState } from './constants';
export var useConversionStore = createServiceStore({
    initialValues: initialState,
    customActions: customActions,
});
